import { Component, Input, OnInit } from '@angular/core';
import { ViajesService } from 'src/app/_services/viajes.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-coche-mix',
  templateUrl: './coche-mix.component.html',
  styleUrls: ['./coche-mix.component.css']
})
export class CocheMixComponent implements OnInit {
  @Input() asientosInic: string;
  @Input() asientosSelected: string[];
  @Input() bloqueado: number;
  bloquear: boolean;
  asientos: string[];
  routeComponent;
  constructor(
    private viajesService: ViajesService,
    private router: Router
  ) { }

  ngOnInit(): void {
    console.log(this.router.url);
    this.routeComponent = this.router.url;
    if(this.asientosInic !== ''&& this.asientosInic){
      this.asientos = this.asientosInic.split('*');
      this.viajesService.changeAsientos(this.asientos);
    }   else {
      this.asientos=[];
    }
    this.bloquear = this.bloqueado===-1?true:false;
  }

  revisarCambio(asiento: string){
    if(this.routeComponent.indexOf('tours/reservation')>-1){
      if(this.asientosSelected.indexOf(asiento)>=0){
        this.asientosSelected.splice(this.asientosSelected.indexOf(asiento),1);
      }else{
        this.asientosSelected.push(asiento);
      }
    }
    var pos = this.asientos.indexOf(asiento);
    if(pos>=0)
      this.asientos.splice(pos,1)
    else
      this.asientos.push(asiento);
    this.viajesService.changeAsientos(this.asientos);
  }

  checkAsiento(asiento: string){
    if(this.asientosInic){
    return this.asientosInic.includes(asiento);
    }
  }
  checkAsientoReserva(asiento: string){
    if(this.routeComponent.indexOf('tours/reservation')>-1){
      if(this.asientosInic){
        return this.asientosInic.includes(asiento);
        }
    }
    return false;

  }
  checkAsientoSelected(asiento: string){
    if(this.asientosSelected){
    return this.asientosSelected.includes(asiento);
    }
  }

}
